var map = {
	"./CA-HTV.jpg": "dAjX",
	"./CA-LSR.jpg": "S+7V",
	"./Electric Insulation Silicone Rubber.jpg": "8/tY",
	"./Fire Retardant Silicone Rubber.jpg": "0z9L",
	"./General Purpose Silicone Rubber For Molding.jpg": "3EU3",
	"./High Resilience Silicone Rubber.jpg": "400A",
	"./High Tear Strength Silicone Rubber For Molding.jpg": "etI3",
	"./High Temperature Resistant Silicone Rubber.jpg": "TDbU",
	"./High Transparency Silicone Rubber.jpg": "+98l",
	"./High Transparent Fumed Silicone Rubber.jpg": "FpKB",
	"./Liquid Silicone Rubber for  Food Kitchen.jpg": "Gbsb",
	"./Liquid Silicone Rubber for Baby Care.jpg": "QP4O",
	"./Liquid Silicone Rubber for Cable Accessories.jpg": "LVtV",
	"./Liquid Silicone Rubber for Medical.jpg": "npIc",
	"./Liquid Silicone Rubber for Molding.jpg": "WXPX",
	"./Roller Silicone Rubber.jpg": "FTVK",
	"./Self-Adhesive Liquid Silocone Rubber.jpg": "1QBK",
	"./Silicone Rubber for Extrusion.jpg": "sqUt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/1bZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product ^\.\/.*$
// module id = /1bZ
// module chunks = 1